import {
    deleteRequest,
    getRequest,
    objectToFormData,
    patchRequest,
    patchRequestFormData,
    postRequestFormData
} from "./utilities/http";
import {IFetchExhibitorsDto, IInsertExhibitor} from "../common/interfaces/exhibitor";
import {toQueryString} from "../utilities/helpers";
import {postRequest} from "./utilities/http";

export const fetchExhibitors = async (fairID: number, data: IFetchExhibitorsDto) => {
    return await getRequest(`/exhibitor/fair/${fairID}?`+toQueryString(data));
};

export const fetchExhibitorsByIds = async (exhibitorIDs: number[]) => {
    return await postRequest(`/exhibitors`, {exhibitorIDs: exhibitorIDs});
};

export const insertExhibitor = async (data: IInsertExhibitor) => {

    const file = data.file;
    //@ts-ignore
    delete data.file;

    const formData = objectToFormData(data);
    if (file !== 'unchanged' && file !== null) {
        formData.append('file', file, file?.name)
    }

    return await postRequestFormData('/exhibitor',formData);
}

export const fetchExhibitor = async (exhibitorID:number)=>{
    return await getRequest(`/exhibitor/${exhibitorID}`);
}

export const updateExhibitor = async (exhibitorID:number,data: IInsertExhibitor) => {

    const file = data.file;
    //@ts-ignore
    delete data.file;

    const formData = objectToFormData(data);
    formData.append('id', exhibitorID + '')
    if (file !== 'unchanged' && file !== null) {
        formData.append('file', file, file?.name)
    }else if(file === 'unchanged'){
        formData.append('logoUnchanged', 'true')
    }

    return await patchRequestFormData('/exhibitor',formData);
}

export const deleteExhibitor = async (exhibitorID:number)=>{
    return await deleteRequest(`/exhibitor/${exhibitorID}`)
}

export const removeExhibitorFromStand = async (exhibitorID: number) => {
    return await patchRequest(`/exhibitor/remove-from-stand/${exhibitorID}`,{})
}

export const importExhibitors = async (floorPlanID: number, file: File) => {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('floorPlanID', floorPlanID.toString());
    return await postRequest(`/import/${floorPlanID}`, formData );
}
